// 表单数据
export const formData = {
    adminId: '08914b87-f9a6-4d99-8887-f6f0e64de3f6',
    title: '',
    classType: 1,
    headImg: 'string',
    dateNews: '',
    status: 1,
    content: ''
}

// 表单验证规则
export const formRules = {
    title: [{ required: true, message: "新闻标题不能为空", trigger: "blur" }],
    classType: [{ required: true, message: "新闻分类不能为空", trigger: "blur" }],
    status: [{ required: true, message: "发布状态不能为空", trigger: "blur" }],
    headImg: [{ required: true, message: "广告图片不能为空", trigger: "blur" }],
    dateNews: [{ required: true, message: "新闻时间不能为空", trigger: "blur" }],
    // content: [{ required: true, message: "新闻内容不能为空", trigger: "blur" }],
}